import React, { Component } from "react";
import {
  Table,
  Button,
  TablePropertyFiltering,
  TablePagination,
  TableSelection,
  TableSorting,
  TablePreferences,
  TablePageSizeSelector,
  TableWrapLines,
  TableContentSelector,
} from "@amzn/awsui-components-react/polaris";
import {
  defaultPageSize,
  columnDefinitions,
  defaultSortingColumn,
  sortableColumns,
  visibleColumns,
  filteringOptions,
  features,
} from "./table-config";
import { LandingTableRow } from "../../../model/landing";
import { customizedFilteringFunction } from "../../../components/polaris/table/property-filtering-utils";
import { exportCSVFunc } from "@amzn/lens-react-ui";
import constants from '../../../constants';

// declare prop check
type Props = {
  data: Array<LandingTableRow>;
  loadingStatus: any;
  test_case_id: string;
} & typeof defaultProps;

type State = typeof initialState;

const defaultProps = Object.freeze({});

const initialState = Object.freeze({
  currentPageIndex: 1,
  pagesCount: 0,
});

class FinalPowerTable extends Component<Props, State> {
  static defaultProps = defaultProps;
  state = initialState;

  _onPaginationChange = (event) => {
    const { currentPageIndex, pagesCount } = event.detail;
    this.setState({
      currentPageIndex,
      pagesCount,
    });
  };

  render() {
    const { data, loadingStatus, test_case_id } = this.props;
    return (
      <Table
        loadingText="Loading"
        columnDefinitions={columnDefinitions}
        items={data}
        loading={loadingStatus == constants.LOADING_LOAD} 
        features={features}
        header={
          <div className="awsui-util-action-stripe">
            <div className="awsui-util-action-stripe-title">
              <h2>
                Testcase Final Power &nbsp;
                <span className="awsui-util-header-counter">{`(${data.length})`}</span>
              </h2>
            </div>
            <div className="awsui-util-action-stripe-group">
              <Button
                icon="download"
                variant="primary"
                disabled={!data || data.length == 0}
                onClick={() =>
                  exportCSVFunc(
                    data,
                    test_case_id + " " + "Final Power Data"
                  )
                }
              >
                Export Table
              </Button>
            </div>
          </div>
        }
        empty={
          <div className="awsui-util-t-c">
            <div className="awsui-util-pt-s awsui-util-mb-xs">
              <b>No resources</b>
            </div>
            <p className="awsui-util-mb-s">No resources to display.</p>
          </div>
        }
        noMatch={
          <div className="awsui-util-t-c">
            <div className="awsui-util-pt-s awsui-util-mb-xs">
              <b>No matches</b>
            </div>
            <p className="awsui-util-mb-s">We can’t find a match.</p>
            <div className="awsui-util-mb-m">
              <Button>Clear filter</Button>
            </div>
          </div>
        }
      >
        <TablePropertyFiltering
          filteringOptions={filteringOptions}
          filteringFunction={customizedFilteringFunction}
          groupValuesText="Values"
          groupPropertiesText="Properties"
          operationAndText="and"
          operationNotAndText="and not"
          operationOrText="or"
          operationNotOrText="or not"
          clearFiltersText="Clear filter"
          placeholder="Filter resources by property or value"
          allowFreeTextFiltering={true}
          filteringCountTextFunction={(count) =>
            `${count} ${count === 1 ? "match" : "matches"}`
          }
        ></TablePropertyFiltering>
        <TablePagination
          pageSize={defaultPageSize}
          onPaginationChange={this._onPaginationChange}
        ></TablePagination>
        <TableSorting
          sortingColumn={defaultSortingColumn}
          sortableColumns={sortableColumns}
          sortingDescending={true}
        ></TableSorting>
        <TablePreferences
          title="Preferences"
          confirmLabel="Confirm"
          cancelLabel="Cancel"
        >
          <TablePageSizeSelector
            title="Page size"
            options={[
              { value: 3, label: "3 items" },
              { value: 5, label: "5 items" },
              { value: 10, label: "10 items" },
            ]}
          />
          <TableWrapLines
            label="Wrap lines"
            description="Enable to wrap table cell content, disable to truncate text."
          />
          <TableContentSelector
            title="Select visible columns"
            options={visibleColumns}
          />
        </TablePreferences>
      </Table>
    );
  }
}

export default FinalPowerTable;
